module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/company-digest/funds-digest/funds-digest.component.css
// module id = ./src/app/web/game/management/company-digest/funds-digest/funds-digest.component.css
// module chunks = main